<template>

    <span>

        <b-form-row>
                                
            <b-col>
            
            <b-form-group
                id="signup-firstName-group"
                label-for="firstName"
                description="Your first name, or given name."
                :state="localFormValidation.firstName" 
                valid-feedback="Looks good!"
                invalid-feedback="This information is required."
            >
                <label class="detail-label" for="firstName">FIRST NAME</label>        
                <b-form-input
                id="firstName"
                v-model.trim="localUserData.firstName" 
                :state="localFormValidation.firstName"
                size="sm"
                />

            </b-form-group>

            </b-col>

            <b-col>
                        
            <b-form-group
                id="signup-lastName-group"
                label-for="lastName"
                description="Your last name, surname, or family name."
                :state="localFormValidation.lastName" 
                valid-feedback="Looks good!"
                invalid-feedback="This information is required."
            >
                <label class="detail-label" for="lastName">LAST NAME</label>        
                <b-form-input
                id="lastName"
                v-model.trim="localUserData.lastName" 
                :state="localFormValidation.lastName"
                size="sm"
                />

            </b-form-group>

            </b-col>

        </b-form-row>

        <b-form-row class="mt-3">

            <b-col cols="6">
                        
                <b-form-group
                    id="signup-goesBy-group"
                    label-for="goesBy"
                    description="Your nickname or alias."
                    :state="localFormValidation.goesBy" 
                    valid-feedback="Looks good!"
                    invalid-feedback="This information is required.">
                    
                    <label class="detail-label" for="goesBy">PREFERRED NAME</label>        
                    <b-form-input
                    id="goesBy"
                    v-model.trim="localUserData.goesBy" 
                    :state="localFormValidation.goesBy"
                    size="sm">
                    
                        <!--
                            20200409 -- ZWS -- @TODO -- I'll likely need a way to
                            implement this when adding this component to the
                            sign-up page
                        {{ this.auth0User.nickname }}
                        -->
                    
                    </b-form-input>

                </b-form-group>

            </b-col>

            <b-col>
                        
                <b-form-group
                    id="signup-timezone-group"
                    label-for="timezone"
                    description="The timezone in which you usually reside."
                    :state="localFormValidation.timezone"
                    valid-feedback="Looks good!"
                    invalid-feedback="This information is required.">
                    
                    <label class="detail-label" for="timezone">TIMEZONE</label>    
                    <b-form-select 
                    id="timezone"
                    v-model.trim="localUserData.timezone" 
                    :state="localFormValidation.timezone"
                    :options="validTimezones"
                    value-field="item"
                    text-field="name"
                    size="sm"
                    />

                </b-form-group>

            </b-col>

        </b-form-row>

        <b-form-row class="mt-3">

            <b-col cols="6">

                <b-form-group
                    id="signup-country-group"
                    label-for="country"
                    description="The country in which you usually reside."
                    :state="localFormValidation.country" 
                    valid-feedback="Looks good!"
                    invalid-feedback="This information is required."
                >
                    <label class="detail-label" for="country">COUNTRY</label>            
                    <b-form-select
                    id="country"
                    v-model.trim="localUserData.country" 
                    :state="localFormValidation.country"
                    :options="countries"
                    value-field="Code"
                    text-field="Name"
                    size="sm"
                    />
                    

                </b-form-group>

            </b-col>

        </b-form-row>

        <b-row>
            <b-col cols="12" style="text-align:right;">
                <b-button v-if="buttonLabel=='Save'" ref="buttonReset" @click="onReset" class="mr-2" variant="warning">
                    Cancel
                </b-button>
                
                <b-button v-if="buttonLabel=='Save'" ref="buttonSave" @click="onSubmit" class="mr-2" variant="success">
                    Save
                </b-button>

                <b-button v-else class="mr-2" variant="success" @click="next('applicationOptions')">
                    Next
                </b-button>
            </b-col>
        </b-row>

    </span>

</template>

<script>

import countries from '../mixins/countries'
import genericOps from '../mixins/genericOps'
import LocalAuth0Service from '../services/LocalAuth0Service';

import moment from 'moment'
import momentTZ from 'moment-timezone'
import StripeField from '@/components/StripeField.vue'

export default {
    name: 'ProfileForm',
    components: {
      StripeField
	},
    mixins: [countries, genericOps],
    props: {
        buttonLabel: {
            type: String,
            default: 'Next'
        },
        displayForNewUser: {
            type: Boolean,
            default: false
        },
        userData: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            ptUserValidation: {
                applicationOptions: null,
                cardError: null,
                cardMessage: null,
                firstName: null,
                lastName: null,
                goesBy: null,
                country: null,
                personalData: null,
                timezone: null,
                referral: null,
                referralSource: null,
                referralCode: null,
                subscription: null,
                subscriptionLevel: null,
                termsOfService: null,
                loadDefaults: null,
            },
            
            
        }
    },
    computed: {
        localUserData: {
            get: function() {
                
                return this.userData
            
            },
            set: function(newValue) {
            }
        },
        localFormValidation: {
            get: function() {
                return this.ptUserValidation
            },
            set: function(newValue) {
                //console.log('Setting localFormValidation to: ')
                //console.log(newValue)
                this.ptUserValidation = newValue
            }
        }
        
    },
    watch: {
        ptUserValidation: function () {
            try {
                //console.log('ptUserValidation changed to: ' + JSON.stringify(this.ptUserValidation))
            } catch(e) {
                //console.log('ptUserValidation changed to: NULL (' + e + ')')
            }
            
        }
    },
    async created() {
        
        this.prepareForm()


    },
    async mounted() {

    },
    methods: {
        
        async onReset(evt){
            
            try {
                evt.preventDefault()
            } catch(e) {
                // Intentionally left blank
            }
            

            
            

            

        },
        onSubmit(evt) {
            
            // 20200409 -- ZWS -- Handles when a user submits the form.
            //
            // Validates the data and, if successful, emits the 
            // submitted:ProfileForm event.
            //
            // This disables the buttons.  The submitted.ProfileForm is
            // expected to enable them when appropriate.
            //
            // Emits: submitted:ProfileForm

            try {
                evt.preventDefault()
            } catch(e) {
                // Intentionally left blank
            }
            
            try {
                this.$refs.buttonReset.disabled = true
                this.$refs.buttonSubmit.disabled = true
            } catch(e) {
                // Intentionally left blank.
            }

            //console.log('resetting form validation')
            this.localFormValidation = {}
            this.localFormValidation.valid = true

            if(typeof this.localUserData.firstName == 'undefined' || this.localUserData.firstName === null || this.localUserData.firstName.length < 1) {
                this.localFormValidation.valid = false  
                this.localFormValidation.firstName = false
                this.localFormValidation.personalData = false
            }

            if(typeof this.localUserData.lastName == 'undefined' || this.localUserData.lastName === null || this.localUserData.lastName.length < 1) {
                this.localFormValidation.valid = false  
                this.localFormValidation.lastName = false
                this.localFormValidation.personalData = false
            }

            

            if(typeof this.localUserData.country == 'undefined' || this.localUserData.country === null || this.localUserData.country.length < 1) {
                this.localFormValidation.valid = false  
                this.localFormValidation.country = false
                this.localFormValidation.personalData = false
            
            }

            if(this.localFormValidation.valid) {

                this.$emit('submitted:ProfileForm', this.localUserData)

                this.$refs.buttonReset.disabled = false
                this.$refs.buttonSubmit.disabled = false
            
            } else {
                
                this.$refs.buttonReset.disabled = false
                this.$refs.buttonSubmit.disabled = false
            
            }

        },
        prepareForm() {
            
            //console.log('resetting form validation')
            this.localFormValidation = {}
            this.localFormValidation.valid = true

            let zoneNames = momentTZ.tz.names()

            this.validTimezones = zoneNames.map(x => {
                return {name: x, item: x}
            })
            
            try {
                this.$refs.buttonReset.disabled = false
                this.$refs.buttonSubmit.disabled = false
            } catch(e) {
                // Intentionally left blank.
            }

        },
        
    }
}
</script>

<style scoped>.detail-label{font-size:0.625rem;font-weight:500;color:var(--text-secondary);margin-bottom:var(--spacing-xs);text-transform:uppercase;letter-spacing:0.05em;display:block}.task-card-actions-footer{display:flex;justify-content:flex-end;align-items:center;gap:0.5rem;padding-top:1rem;border-top:1px solid #e9ecef;margin-top:1rem}</style>
